export const BASE_WEBSOCKET_URL = process.env.BASE_WEBSOCKET_URL;
export const BASE_API_URL = process.env.NEXT_PUBLIC_BASE_API_URL;
export const NEXT_PUBLIC_IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URL;
